import { render, staticRenderFns } from "./ExpenseReport.vue?vue&type=template&id=2ff16a7d"
import script from "./ExpenseReport.vue?vue&type=script&lang=js"
export * from "./ExpenseReport.vue?vue&type=script&lang=js"
import style0 from "./ExpenseReport.vue?vue&type=style&index=0&id=2ff16a7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports